// actions/employee-onboarding/reminder.js

import { attachAuth } from '../../utils/authService';

export function reminderHasErrored(bool) {
  return {
    type: 'ONBOARDING_REMINDER_HAS_ERRORED',
    hasErrored: bool
  };
}

export function reminderIsLoading(bool) {
  return {
    type: 'ONBOARDING_REMINDER_IS_LOADING',
    isLoading: bool
  };
}

export function reminderFetchDataSuccess(data) {
  return {
    type: 'ONBOARDING_REMINDER_FETCH_DATA_SUCCESS',
    data
  };
}

export function reminderFetchData(host, params) {
  return (dispatch) => {
    dispatch(reminderIsLoading(true));
    dispatch(reminderHasErrored(false));
    fetch(host + 'admin/reminder', {
      method: 'post',
      body: JSON.stringify(params),
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            dispatch(reminderFetchDataSuccess(result));
            dispatch(reminderHasErrored(false));
            dispatch(reminderIsLoading(false));
          })
          .catch((ex) => {
            console.log(ex);
            dispatch(reminderHasErrored(true));
            dispatch(reminderIsLoading(false));
          });
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(reminderHasErrored(true));
      dispatch(reminderIsLoading(false));
    });
  };
}